export const GET_CUSTOMER_BY_EMAIL = 'mac/FETCH_GET_CUSTOMER_BY_EMAIL';
export const IS_MEMBER_OF_GROUP = 'mac/FETCH_IS_MEMBER_OF_GROUP';
export const IS_EMAIL = 'mac/FETCH_IS_EMAIL';
export const EXTERNAL = 'mac/FETCH_EXTERNAL';
